import styles from './UserProfile.module.scss';
import IconProfile from '@/app/_images/ico_profile.svg';

interface UserProfileProps {
  userInfo: string;
}

const UserProfile = ({ userInfo }: UserProfileProps) => {
  return (
    <div className={styles.profile}>
      <div className={styles.icon}>
        <IconProfile />
      </div>
      <span>{userInfo.length ? userInfo : 'null@email.com'}</span>
    </div>
  );
};

export default UserProfile;
